import { NavLink, Outlet } from "react-router-dom";

const TABS = [
  { to: "/sales", label: "Dashboard", end: true, id: "dashboard" },
  { to: "/sales/companies", label: "Companies", id: "companies" },
  { to: "/sales/pipeline", label: "Pipeline", id: "pipeline" },
  { to: "/sales/followups", label: "My Follow-ups", id: "followups" },
  { to: "/sales/import", label: "Import Leads", id: "import" },
  { to: "/sales/settings", label: "Settings", id: "settings" },
];

export default function SalesLayout() {
  return (
    <div data-testid="sales-layout">
      <nav className="scrollbar-thin -mx-1 mb-8 flex gap-1 overflow-x-auto border-b pb-px">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.end} data-testid={`sales-tab-${t.id}`}
            className={({ isActive }) => `whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors ${isActive ? "border-cyan-400 text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
